import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchNotifications, dispatchNotification, markNotificationRead } from '../../services/api/notificationService';

export const loadNotifications = createAsyncThunk('notifications/load', async () => fetchNotifications());

export const sendNewNotification = createAsyncThunk('notifications/send', async (payload) => dispatchNotification(payload));

export const markNotificationAsRead = createAsyncThunk('notifications/read', async (id) => markNotificationRead(id));

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadNotifications.pending, (state) => { state.status = 'loading'; })
      .addCase(loadNotifications.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadNotifications.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(sendNewNotification.fulfilled, (state, action) => {
        state.items.unshift(...action.payload);
      })
      .addCase(markNotificationAsRead.fulfilled, (state, action) => {
        const item = state.items.find((n) => n.id === action.payload.id);
        if (item) item.readByRecipient = true;
      });
  }
});

export default notificationsSlice.reducer;
